<template>
  <div class="single-product" @click="$bvModal.show(modalId)">
    <div class="count-area">
      <a href="#" @click.stop="handleMinus($event)">
        <span class="icon-icon_less"></span>
      </a>
      <div class="quantity" :title="product.count">{{ currentQuantity }}</div>
      <a href="#" @click.stop="handlePlus($event)">
        <span class="icon-icon_add"></span>
      </a>
    </div>

    <div class="single-product__name">
      {{ product.name + specName }}
    </div>

    <div class="single-product__price">$ {{ productPrice }}</div>
    <ProductModal :id="id" :product="product" :productIndex="index" />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import cloneDeepWith from 'lodash/cloneDeepWith';
import ProductModal from '@/components/Modal/ProductModal';
import _ from 'lodash';

export default {
  components: {
    ProductModal
  },
  props: {
    id: {
      type: String,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  watch: {
    'product.count': function(newValue) {
      this.currentQuantity = newValue;
    }
  },
  computed: {
    modalId() {
      return `product-modal-${this.id}`;
    },
    productParams() {
      let temp = cloneDeepWith(this.product);

      return Object.assign(temp, {
        count: this.currentQuantity
      });
    },
    firstSpecName() {
      return _.get(this.product, 'product_spec.first_spec_name', null);
    },
    secondSpecName() {
      return _.get(this.product, 'product_spec.second_spec_name', null);
    },
    specName() {
      if (this.firstSpecName == null) {
        return '';
      } else if (this.secondSpecName == null) {
        return `(${this.firstSpecName})`;
      } else {
        return `(${this.firstSpecName}/${this.secondSpecName})`;
      }
    },
    productPrice() {
      return this.currentQuantity * this.product.price;
    }
  },
  data() {
    return {
      currentQuantity: 1
    };
  },
  created() {
    this.currentQuantity = this.product.count;

    // 清空優惠卷
    this.setCoupons([]);
    // 重新計算訂單金額
    this.calcOrderPrice();
  },
  methods: {
    ...mapActions('order', ['addProduct', 'removeProduct', 'calcOrderPrice']),
    ...mapMutations('order', ['setCoupons']),
    handlePlus(e) {
      e.preventDefault();
      this.currentQuantity = this.currentQuantity + 1;

      this.addProduct({ product: this.productParams, push: false });
    },
    handleMinus(e) {
      e.preventDefault();
      let count = this.currentQuantity - 1;

      if (count == 0) {
        this.removeProduct({
          productId: this.product.product_id,
          productIndex: this.index
        });
      } else {
        this.currentQuantity = count;

        this.addProduct({ product: this.productParams, push: false });
      }
    }
  }
};
</script>
